module.exports = __webpack_public_path__ + "img/moments-box-img.681ef25d.webp";